var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparklingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Template"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 578",
    d: "M7.6802 0.5H7.3198C6.84312 0.5 6.43271 0.83646 6.33922 1.30388L5.63074 4.84628C5.55157 5.24214 5.24214 5.55157 4.84628 5.63074L1.30388 6.33922C0.83646 6.43271 0.5 6.84312 0.5 7.3198V7.6802C0.5 8.15688 0.83646 8.56729 1.30388 8.66078L4.84628 9.36926C5.24214 9.44843 5.55157 9.75786 5.63074 10.1537L6.33922 13.6961C6.43271 14.1635 6.84312 14.5 7.3198 14.5H7.6802C8.15688 14.5 8.56729 14.1635 8.66078 13.6961L9.36926 10.1537C9.44843 9.75786 9.75786 9.44843 10.1537 9.36926L13.6961 8.66078C14.1635 8.56729 14.5 8.15688 14.5 7.6802V7.3198C14.5 6.84312 14.1635 6.43271 13.6961 6.33922L10.1537 5.63074C9.75786 5.55157 9.44843 5.24214 9.36926 4.84628L8.66078 1.30388C8.56729 0.83646 8.15688 0.5 7.6802 0.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 579",
    d: "M13.5 0.5V2.5M12.5 1.5H14.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklingFilled);
export default __webpack_public_path__ + "static/media/sparkling-filled.0ae5150894600508615f74eb3a456efe.svg";
export { ForwardRef as ReactComponent };